//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfButton from './SfButton/SfButton.vue';
import SfQuantitySelector from './SfQuantitySelector.vue';

export default {
  name: 'SfAddToCart',
  components: {
    SfButton,
    SfQuantitySelector,
  },
  model: {
    prop: 'qty',
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    qty: {
      type: [Number, String],
      default: 1,
    },
  },
};
